import React from 'react';

import { Image } from '../../../foundations/Image/Image';
import { buildImageSizes } from '../../../foundations/Image/utils/buildImageSizes';
import type { ImageSrcSet } from '../../../foundations/Image/utils/buildImageSrcSet';
import { buildImageSrcSet } from '../../../foundations/Image/utils/buildImageSrcSet';
import { CATEGORY_CARD_MEDIUM_IMAGE_SIZE, CATEGORY_CARD_SMALL_IMAGE_SIZE } from '../constants';
import type { CategoryCardProps } from '../types';
import * as styles from './CategoryCard.styles';

export const CategoryCard = ({
  backgroundColor,
  categoryHref,
  categoryName,
  imageHeight,
  imageWidth,
  images,
  lazyImages,
  onLinkClick,
}: CategoryCardProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    onLinkClick?.(e);
  };
  const imagesWithUnit: ImageSrcSet[] = images.map(({ src, width }) => ({ src, width, unit: 'w' }));

  return (
    <a css={styles.link} href={categoryHref} onClick={handleClick}>
      <Image
        css={styles.image}
        height={imageHeight}
        loading={lazyImages ? 'lazy' : 'eager'}
        sizes={buildImageSizes({
          XXS: `${CATEGORY_CARD_SMALL_IMAGE_SIZE}px`,
          M: `${CATEGORY_CARD_MEDIUM_IMAGE_SIZE}px`,
        })}
        src={images[0]?.src}
        srcSet={buildImageSrcSet(imagesWithUnit)}
        width={imageWidth}
      />
      <p
        css={styles.categoryTitle}
        style={
          {
            '--backgroundColor': backgroundColor,
          } as styles.BackgroundColorCSSProperties
        }
      >
        {categoryName}
      </p>
    </a>
  );
};
